import { Box, Button } from "@mui/material";
import { Typography } from "@powerdiary/components-library/lib";
import { useState } from "react";
import { selectBookingType, useClientPortalSelector } from "../../../../redux";
import { ROUTES } from "../../../../routes";
import { LoginDialogMode, RegisterMode } from "../../../Account/Account.types";
import LoginDialogForm from "../../../Account/LoginDialog/LoginDialogForm";
import RegisterDialogForm from "../../../Account/LoginDialog/RegisterDialogForm";
import ResetPasswordForm from "../../../Account/LoginDialog/ResetPasswordForm";
import styles from "./Register.module.css";
import { BookingType } from "types/appointmentBooking";

type RegisterFormMode = "register" | "login";

export default function Register() {
    const [loginMode, setLoginMode] = useState<LoginDialogMode>(LoginDialogMode.Login);
    const [mode, setMode] = useState<RegisterFormMode>("login");
    const bookingType = useClientPortalSelector(selectBookingType);

    const getReturnUrl = (): string => {
        return bookingType === BookingType.CLIENT ? ROUTES.APPOINTMENT_BOOKING.urlPath : ROUTES.CLASS_BOOKING.urlPath;
    };

    return (
        <Box className={styles.wrapper}>
            {mode === "login" && (
                <>
                    {loginMode === LoginDialogMode.Login ? (
                        <LoginDialogForm setMode={setLoginMode} returnUrl={getReturnUrl()} />
                    ) : (
                        <ResetPasswordForm setMode={setLoginMode} />
                    )}
                    <Typography mt={3} variant="paragraphExtraLargeRegular">
                        First time on our client portal?
                    </Typography>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => setMode("register")}
                        data-test-id="button_appointment_booking_button_register"
                    >
                        Register here
                    </Button>
                </>
            )}

            {mode === "register" && (
                <RegisterDialogForm registerMode={RegisterMode.Create} setMode={() => setMode("login")} />
            )}
        </Box>
    );
}
